import React, { useState } from "react";
import styles from "./Header.module.scss";
import imgLogo from "../../../assets/images/Transport_for_NSW.png";
import userManager from "../../../userManager";
import { Button } from "@onegovbugs/onegov-react-components";
import { useSelector } from "react-redux";
import IdleTimer from "react-idle-timer";
import { useDispatch } from "react-redux";
import { IDLE_TIMEOUT, RESET_INTERVAL_S } from '../constants/Constant'
import TimerModal from "../timer/TimerModal";


const Header = () => {
  const oidc = useSelector(state => state.oidc);
  const { user, isLoadingUser } = oidc;
  const userExists = user && !isLoadingUser;
  const [logoutMode, setLogoutMode] = useState(false);
  const [showTimerModal, setTimerModal] = useState(false);
  const application = useSelector(state => state.application);
  const dispatch = useDispatch();
  const[idleTimeOut,setIdleTimeOut] = useState(IDLE_TIMEOUT);
  
  const onIdle = () => {
    setTimerModal(true);
  }

  return (
    <div>
      {
        oidc.user ? (
          <div className={`row`}>
            <div className={`col-12`}>
           
               <TimerModal
                        // onSave={handleSubmit(onSubmit)}
                         onDiscard={() => {userManager.signoutRedirect();setTimerModal(false)}}
                         onStay={()=>{setIdleTimeOut(IDLE_TIMEOUT);setTimerModal(false)}}
                        show={showTimerModal}
                        //modalBody={dirtyFieldsList}
                        modalTitle="You are idle for a while"
                    />
                     {
                <IdleTimer
                  timeout={idleTimeOut - 1000 * RESET_INTERVAL_S}
                  onIdle={onIdle}
                  // onActive={onActive}
                />
              }
            </div>
          </div>
        ) : null}
      <div className={styles.logoContainer}>
        <div className={`row`}>
          <div className={`col-8`}>
            <a href="\"><img src={imgLogo} alt="NSW Government Health Logo" className={styles.logo} /></a>
          </div>
          <div className={`col-4 ${styles.logoutCont}`}>
            {userExists ? <Button secondary onClick={() => userManager.signoutRedirect()}>Logout</Button> :
              <Button secondary onClick={() => userManager.signinRedirect()}>Login</Button>}
          </div>
        </div>
      </div>
    </div>
  )
};

export default Header;
